import { Navigate, useRoutes } from 'react-router-dom';
import Dashboard from '../pages/Dashboard';
import Login from '../pages/auth/Login';
import Users from '../pages/Users';
import Orders from '../pages/Orders';
import PendingOrders from '../pages/PendingOrders';
import Invoices from '../pages/Invoices';
import Tickets from '../pages/Tickets';
import LabelPricing from '../pages/LabelPricing';
import SinglePricing from '../pages/SinglePricing';
import Website from '../pages/Website';
import CustomPricing from '../pages/CustomPricing';
import InternationalLabelPricing from '../pages/InternationalLabelPricing';
import SingleInternationalPricing from '../pages/SingleInterLabelPricing';
import InterOrders from '../pages/InterOrders';
import Workers from '../pages/Workers';
import MarketingStats from '../pages/MarketingStats';
import ScanPricing from '../pages/ScanPricing';
import Scans from '../pages/Scans';
import BulkOrders from '../pages/BulkOrders';
import AmazonOrders from '../pages/AmazonOrders';
import NewAmazonOrders from '../pages/NewAmazonOrders';
import Transactions from '../pages/Transactions';
import CryptoSettings from '../pages/CryptoSettings';

const routes = {
    LANDING: '/',
    HOME: '/',
    LOGIN: '/login',
    REGISTER: '/register',
    FORGOT_PASS: '/forgot-password',
    RESET_PASS: '/reset-password',
    FAQS: '/faqs',
    PRICING: '/pricing',
    INTER_PRICING: '/pricing-international',
    ADDRESSES: '/address-book',
    CSV: '/csv-orders',
    DEPOSIT: '/deposit',
    TRANSACTIONS: '/transactions',
    SUPPORT: '/support',
    REFERRALS: '/referrals',
    ADD_LABEL: '/create-label',
    LABELS: '/labels',
    INTLABELS: '/international-orders',
};

const AppRoutes = () =>
    useRoutes([
        {
            path: routes.HOME,
            element: <Dashboard />,
        },
        {
            path: '*',
            element: <Navigate to={routes.HOME} />,
        },
        {
            path: '/users',
            element: <Users />,
        },
        {
            path: '/marketing',
            element: <MarketingStats />,
        },
        {
            path: '/customPricing/:id',
            element: <CustomPricing />,
        },
        {
            path: '/orders',
            element: <Orders />,
        },
        {
            path: '/pending-orders',
            element: <PendingOrders />,
        },
        {
            path: '/international-orders',
            element: <InterOrders />,
        },
        {
            path: '/invoices',
            element: <Invoices />,
        },
        {
            path: '/tickets',
            element: <Tickets />,
        },
        {
            path: '/workers',
            element: <Workers />,
        },
        {
            path: '/labelPricing',
            element: <LabelPricing />,
        },
        {
            path: '/labelPricing/:id',
            element: <SinglePricing />,
        },

        {
            path: '/scans',
            element: <Scans />,
        },
        {
            path: '/bulk-orders',
            element: <BulkOrders />,
        },
        {
            path: '/amazon-orders',
            element: <AmazonOrders />,
        },
        {
            path: '/new-amazon-orders',
            element: <NewAmazonOrders />,
        },
        {
            path: '/transactions',
            element: <Transactions />,
        },
        {
            path: '/scan-pricing',
            element: <ScanPricing />,
        },
        {
            path: '/labelPricing-international',
            element: <InternationalLabelPricing />,
        },
        {
            path: '/labelPricing-international/:id',
            element: <SingleInternationalPricing />,
        },
        {
            path: '/crypto-settings',
            element: <CryptoSettings />,
        },
        {
            path: '/website',
            element: <Website />,
        },
    ]);

const WorkerRoutes = () =>
    useRoutes([
        {
            path: '*',
            element: <InterOrders />,
        },
        {
            path: '/international-orders',
            element: <InterOrders />,
        },
    ]);

const AuthRoutes = () =>
    useRoutes([
        {
            path: '/',
            element: <Navigate to={'/login'} />,
        },
        {
            path: '*',
            element: <Navigate to={'/login'} />,
        },

        {
            path: '/login',
            element: <Login />,
        },
    ]);

export { AuthRoutes, AppRoutes, WorkerRoutes };

export default routes;
